import { FormEngineModeTypeEnum } from '@celito.clients/enums';
import { useActiveModule, useLayout } from '@celito.clients/hooks';
import { getRecordDetailApi } from '@celito.clients/services';
import { useBreadcrumbs } from '@celito.clients/shared';
import { raiseErrorToast } from '@celito.clients/utils';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { SingleLayoutContainerProps } from '../single-layout-container.model';
import ViewLayoutView from './view.view';

export const ViewLayoutController = (props: SingleLayoutContainerProps) => {
  const {
    sections = [],
    objectName,
    recordName,
    attributeConfig,
    goToEditScreen,
  } = props;

  const { configureLayout } = useLayout();
  const navigate = useNavigate();
  const activeModule = useActiveModule();
  const { getParentBreadcrumbUrl } = useBreadcrumbs();

  const [recordDetails, setRecordDetails] = useState<Record<string, unknown>>(
    {}
  );
  const [isLoadingRecord, setIsLoadingRecord] = useState(true);

  const onRouteBack = () => {
    const parentUrl = getParentBreadcrumbUrl();
    if (parentUrl) {
      navigate(parentUrl);
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(activeModule?.link || '/');
    }
  };

  const callRecordDetailApi = async (
    objectName: string,
    recordName: string
  ) => {
    try {
      setIsLoadingRecord(true);
      const response = await getRecordDetailApi(objectName, recordName, {
        view_type: FormEngineModeTypeEnum.View,
      });
      if (response?.title)
        configureLayout({
          pageTitle: '',
          enablePadding: false,
          headerTitle: (response?.title as string) || '',
        });

      setRecordDetails(response);
      props?.setRecordData?.(response);
    } catch (_error) {
      raiseErrorToast(_error);
    } finally {
      setIsLoadingRecord(false);
    }
  };

  console.info(
    `[ViewLayoutController] render objectName=${objectName} recordName=${recordName} sections=${sections?.length} fields=${sections?.[0]?.fields?.length} isLoading=${isLoadingRecord} hasRecord=${Object.keys(recordDetails).length > 0}`
  );

  useEffect(() => {
    console.info(
      `[ViewLayoutController] useEffect objectName=${objectName} recordName=${recordName}`
    );
    if (objectName && recordName) callRecordDetailApi(objectName, recordName);
    configureLayout({
      pageTitle: '',
      enablePadding: false,
      headerTitle: '',
      showHeadingLoader: true,
    });
  }, [objectName, recordName]);

  return (
    <ViewLayoutView
      {...props}
      {...{
        onCancel: onRouteBack,
        goToEditScreen,
        sections,
        mode: props.mode,
        recordDetails,
        attributeConfig,
        isLoadingRecord,
        callRecordDetailApi,
      }}
    />
  );
};
